// extracted by mini-css-extract-plugin
module.exports = {"settingsScreen":"styles_settingsScreen__2iGiM","options":"styles_options__3JHfO","toolbar":"styles_toolbar__12WFi"};